import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://abdvlbsbatfnrdnjcmus.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFiZHZsYnNiYXRmbnJkbmpjbXVzIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTU1MTMyNDUsImV4cCI6MjAxMTA4OTI0NX0.EeefJDuHWeULMcBzZ2BmlEwOGUdESYHSlnp7VOMuHA0'

const supabase = createClient(supabaseUrl, supabaseAnonKey)

export default supabase;
